import React from 'react';
import './Support.css';
import { FaTelegram } from 'react-icons/fa';

function Support() {
  const openTelegramSupport = () => {
    const tg = window.Telegram?.WebApp;
    const supportUsername = 'zhaga_vpn';
    
    if (tg) {
      tg.openTelegramLink(`https://t.me/${supportUsername}`);
    } else {
      window.open(`https://t.me/${supportUsername}`, '_blank');
    }
  };

  return (
    <div className="page-container support-page" style={{paddingTop: '60px'}}>
      <h1 className="page-title">Поддержка</h1>
      <p className="support-description">
        Если у вас возникли вопросы или проблемы, наша служба поддержки всегда готова помочь!
      </p>
      
      <div className="support-card">
        <FaTelegram className="telegram-icon" />
        <h2>Свяжитесь с нами</h2>
        <p>Напишите нам в Telegram, и мы оперативно ответим на все ваши вопросы</p>
        <button onClick={openTelegramSupport} className="support-button">
          <FaTelegram /> Написать в поддержку
        </button>
      </div>
      
      <div className="support-info">
        <p>⏰ Время ответа: обычно в течение 1 часа</p>
        <p>📱 Поддержка работает 24/7</p>
      </div>
    </div>
  );
}

export default Support; 